// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__0OekM","stepStyle":"style_stepStyle__3F5I9"};